var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8659 5.94594V0.372813L12.0271 2.21281C10.5709 0.759688 8.88148 0.0234375 6.95836 0.0234375C3.11711 0.0234375 -0.00851562 3.15469 -0.00976562 7.00031C-0.00914062 10.8453 3.11711 13.9741 6.95898 13.9753C9.63148 13.9753 12.8146 12.5834 13.7315 8.67656L13.749 8.60031H11.7302L11.7165 8.64281C11.0427 10.6691 9.13023 12.0309 6.95836 12.0309C6.29747 12.0325 5.64283 11.9029 5.03231 11.6499C4.42179 11.3968 3.8675 11.0252 3.40148 10.5566C2.93303 10.0907 2.56163 9.53663 2.30877 8.92631C2.0559 8.31599 1.92661 7.66157 1.92836 7.00094C1.92836 4.22719 4.18523 1.97031 6.95961 1.97031C8.25273 1.97031 9.23336 2.33281 10.6621 3.57844L8.29211 5.94656H13.8659V5.94594Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/ReloadIcon.acdaeb1eddb3041a8cf71c03c08b7dda.svg";
export { ForwardRef as ReactComponent };